module.exports = __webpack_public_path__ + "static/media/miniqrcode.d1852262.jpeg";